export default __webpack_public_path__ + "static/media/background.02e52a35.png";